import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, pxToRem } from '@modernhealth/vital-components';

interface Props {
    onClick: () => void;
}

const ButtonWrapper = styled('div')({
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: pxToRem(24),
    width: '100%',
});

export const AbandonButton: React.FC<Props> = ({ onClick }) => {
    const { t } = useTranslation();

    return (
        <ButtonWrapper>
            <IconButton
                icon="x"
                onClick={onClick}
                size="medium"
                title={t('intakeForms:abandon_button.close')}
            />
        </ButtonWrapper>
    );
};
